import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Zap } from 'lucide-react';

const sections = [
  'Working Memory',
  'Processing Speed',
  'Fluid Reasoning',
  'Attention & Focus',
  'Spatial Intelligence'
];

export default function CognitiveCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/assessment/cognitive/verify')}
      className="cognitive-card group relative w-full text-left overflow-hidden rounded-3xl p-6 md:p-7 transition-all duration-300"
    >
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-violet-500/10 to-purple-700/10 pointer-events-none" />

      <div className="relative z-10 flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-violet-500 to-purple-700 text-white flex items-center justify-center shadow-lg shadow-violet-500/30">
            <Zap className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-outfit">NeuroPeak Cognitive Battery</h3>
            <p className="text-sm text-slate-600">5 Sections · 50 Questions · ~40 min</p>
          </div>
        </div>

        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-violet-100/85 text-violet-800 border border-violet-200">
          New
        </span>
      </div>

      <p className="relative z-10 mt-4 text-sm leading-6 text-slate-700">
        Scientifically validated cognitive battery measuring working memory, processing speed, fluid reasoning, sustained attention, and spatial intelligence trusted by leading hiring teams.
      </p>

      <div className="relative z-10 mt-5 flex flex-wrap gap-2">
        {sections.map((section) => (
          <span
            key={section}
            className="text-[11px] md:text-xs px-3 py-1 rounded-full border border-violet-200/80 bg-white/75 text-slate-700 backdrop-blur-sm"
          >
            {section}
          </span>
        ))}
      </div>

      <div className="relative z-10 mt-5">
        <div className="cog-cta-shimmer w-full rounded-xl bg-gradient-to-r from-violet-600 to-purple-700 text-white font-semibold px-4 py-3 flex items-center justify-center gap-2">
          Start Assessment
          <ArrowRight className="h-4 w-4" />
        </div>
      </div>
    </button>
  );
}
